import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const Triangle = styled.div<{
  left?: boolean;
  right?: boolean;
  up?: boolean;
  down?: boolean;
  size?: string;
  color?: string;
}>`
  width: ${({ size }) => size || '5px'};
  height: ${({ size }) => size || '5px'};
  ${({ left, right, up, down, size, color }) => {
    const triangleSize = size || '5px';
    const triangleColor = color || colors.charcoal;

    if (left) {
      return `
        border-top: ${triangleSize} solid transparent;
        border-bottom: ${triangleSize} solid transparent;
        border-right: ${triangleSize} solid ${triangleColor};
      `;
    }

    if (right) {
      return `
        border-top: ${triangleSize} solid transparent;
        border-bottom: ${triangleSize} solid transparent;
        border-left: ${triangleSize} solid ${triangleColor};
      `;
    }

    if (up) {
      return `
        border-left: ${triangleSize} solid transparent;
        border-right: ${triangleSize} solid transparent;
        border-bottom: ${triangleSize} solid ${triangleColor};
      `;
    }

    if (down) {
      return `
        border-left: ${triangleSize} solid transparent;
        border-right: ${triangleSize} solid transparent;
        border-top: ${triangleSize} solid ${triangleColor};
      `;
    }

    return '';
  }};
`;

export default Triangle;
